import { EXTENSION_URL } from "../assets/constants";

export const openExtensionStore = () => {
  window.open(
    `${EXTENSION_URL}?utm_source=landing&utm_medium=button&utm_campaign=landing_to_webstore`,
    "_blank",
    "noopener,noreferrer"
  );
};
